export default __webpack_public_path__ + "static/media/icon-warning.9547d470.svg";